if (!customElements.get('rone-sport-video')) {
  // Every mounted instance registers itself here instead of being found via
  // document.querySelectorAll, so play() on one can pause the others —
  // only one sport-card video should ever play at a time.
  const instances = new Set();

  customElements.define(
    'rone-sport-video',
    class RoneSportVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.playBtn = this.querySelector('[data-rone-video-play]');
        if (!this.video || !this.playBtn) return;

        instances.add(this);

        this.playBtn.addEventListener('click', () => this.video.play());
        this.video.addEventListener('play', () => this.handlePlay());
        this.video.addEventListener('pause', () => this.classList.remove('rone-sport__media--playing'));
        this.video.addEventListener('ended', () => this.classList.remove('rone-sport__media--playing'));
      }

      disconnectedCallback() {
        instances.delete(this);
      }

      handlePlay() {
        this.classList.add('rone-sport__media--playing');
        instances.forEach((other) => {
          if (other !== this && other.video && !other.video.paused) other.video.pause();
        });
      }
    }
  );
}
